<nbc-alert></nbc-alert>
<div *ngIf="gridData?.items?.length > 0" style="overflow-x: auto; overflow-y: hidden;">
  <div class="grid-table">
    <div class="hdr-grid-row grid-row">
      <div class="hdr-grid-col text-center grid-col-15">

      </div>
      <div class="hdr-grid-col psd text-center grid-col-60"
           [ngClass]="gridData.query.sortByColumn === 'positionStartDate'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)"
           data-sort-column-name="positionStartDate"
           class="sortable-column text-nowrap" style="text-transform:uppercase"
           (click)="sortOnColumn('positionStartDate')">
          Position <br />Start Date
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'positionStartDate'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>

      <div class="hdr-grid-col con text-center grid-col-125"
           [ngClass]="gridData.query.sortByColumn === 'contact'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)"
           data-sort-column-name="contact"
           class="sortable-column text-nowrap" style="text-transform:uppercase"
           (click)="sortOnColumn('contact')">
          Contact Name
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'contact'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>

      <div class="hdr-grid-col hm text-center grid-col-110"
           [ngClass]="gridData.query.sortByColumn === 'hiringManager'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)"
           data-sort-column-name="hiringManager"
           class="sortable-column text-nowrap" style="text-transform:uppercase"
           (click)="sortOnColumn('hiringManager')">
          Hiring Manager
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'hiringManager'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>

      <div class="hdr-grid-col pt text-center grid-col-85"
           [ngClass]="gridData.query.sortByColumn === 'registrationStatus'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)"
           data-sort-column-name="registrationStatus"
           class="sortable-column text-nowrap" style="text-transform:uppercase"
           (click)="sortOnColumn('registrationStatus')">
          Registration Status
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'registrationStatus'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>

      <div class="hdr-grid-col pt text-center grid-col-85"
           [ngClass]="gridData.query.sortByColumn === 'employeeType'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)"
           data-sort-column-name="employeeType"
           class="sortable-column text-nowrap" style="text-transform:uppercase"
           (click)="sortOnColumn('employeeType')">
          Employee Type
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'employeeType'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>

      <div class="hdr-grid-col hm text-center grid-col-110"
           [ngClass]="gridData.query.sortByColumn === 'proxyName'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)"
           data-sort-column-name="hiringManager"
           class="sortable-column text-nowrap" style="text-transform:uppercase"
           (click)="sortOnColumn('proxyName')">
          Proxy Name
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'proxyName'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>

      <div class="hdr-grid-col empty grid-col-20">
        &nbsp;
      </div>
      <div class="hdr-grid-col hm text-center grid-col-90"
           [ngClass]="gridData.query.sortByColumn === 'sso'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)" data-sort-column-name="sso" class="sortable-column text-nowrap"
           style="text-transform:uppercase" (click)="sortOnColumn('sso')">
          SSO
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'sso'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>
      <div class="hdr-grid-col hm text-center grid-col-90"
           [ngClass]="gridData.query.sortByColumn === 'employmentStatus'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)" data-sort-column-name="employmentStatus" class="sortable-column text-nowrap"
           style="text-transform:uppercase" (click)="sortOnColumn('employmentStatus')">
          Employee Status
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'employmentStatus'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>
      <div class="hdr-grid-col text-center grid-col-60"
           [ngClass]="gridData.query.sortByColumn === 'dateRequested'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)" style="text-transform:uppercase"
           data-sort-column-name="dateRequested"
           class="sortable-column text-nowrap"
           (click)="sortOnColumn('dateRequested')">
          Date <br />Requested
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'dateRequested'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>

      <div class="hdr-grid-col text-center hdr-grid-col-hlight grid-col-120">
        Contact Type
      </div>

      <div *ngIf="hasTalentSu" class="hdr-grid-col text-center hdr-grid-col-hlight grid-col-120">
        I9 Verify
      </div>

      <div *ngIf="hasTalentSu" class="hdr-grid-col text-center hdr-grid-col-hlight sap grid-col-127">
        SAP Position #
      </div>

      <div *ngIf="hasTalentSu" class="hdr-grid-col text-center hdr-grid-col-hlight grid-col-60">
        TAF Submitted
      </div>

      <div class="hdr-grid-col text-center grid-col-60"
           [ngClass]="gridData.query.sortByColumn === 'onboardingStatusUpdatedDate'?'hdr-grid-col-sorted':''">
        <a href="javascript:void(0)" style="text-transform:uppercase"
           data-sort-column-name="onboardingStatusUpdatedDate"
           class="sortable-column text-nowrap"
           (click)="sortOnColumn('onboardingStatusUpdatedDate')">
          LAST ACTION
          <span class="th-sort">
            <span *ngIf="gridData.query.sortByColumn === 'onboardingStatusUpdatedDate'">
              <i class="fa fa-caret-up" *ngIf="gridData.query.reverseSort == false"></i>
              <i class="fa fa-caret-down" *ngIf="gridData.query.reverseSort == true"></i>
            </span>
          </span>
        </a>
      </div>

    </div>

    <!-- Grid Body -->
    <div *ngFor="let listItem of gridData.items; let index=index;" class="grid-row" id="row-{{listItem?.requestNumber}}" ng-attr-data-id="{{listItem?.requestNumber}}">
      <div title="{{listItem?.onboardngStatus}}" class="grid-col grid-col text-center grid-col-15 {{listItem?.requestStatusColor}}">
        <span>
          &nbsp;
        </span>
      </div>
      <div class="grid-col text-center grid-col-60">
        <span class="grid-dtl-text">
          {{listItem.positionStartDate | date:'MM/dd/yyyy' }}
        </span>
      </div>

      <div class="grid-col  text-center grid-col-120">
        <a href="/scorepay/contact/{{listItem?.scoreId ? listItem.scoreId : 0}}"
           target="_blank"
           class="btn-link">
          {{listItem.contactName}}
        </a>
      </div>

      <div class="grid-col  text-center grid-col-100">
        <span class="grid-dtl-text">
          {{listItem.hiringManager}}
        </span>
      </div>

      <div class="grid-col  text-center grid-col-120">
        <span class="grid-dtl-text">
          {{listItem.registrationStatus}}
        </span>
      </div>

      <div class="grid-col  text-center grid-col-80">
        <span class="grid-dtl-text" *ngIf="listItem.employeeType != null">
          {{listItem.employeeType}}
        </span>
      </div>

      <div class="grid-col  text-center grid-col-100">
        <div *ngIf="listItem.proxyName !=''">
          <a href="/scorepay/contact/{{listItem?.proxyId ? listItem.proxyId : 0}}"
             target="_blank"
             class="btn-link">
            {{listItem.proxyName}}
          </a>
        </div>
        <div *ngIf="listItem.proxyName ==''">
          N/A
        </div>
      </div>

      <div class="open-position-modal-el grid-col text-center grid-col-lnk"
           style="background-color:#e6b800"
           data-request-no="{{listItem.requestNumber}}"
           data-crew-registration-no="{{listItem.registrationNo}}"
           (click)="openOnboardingModal(listItem)">
        <i class="fa fa-ellipsis-h"></i>
      </div>

      <div class="grid-col text-center grid-col-80">
        <span class="grid-dtl-text">
          {{listItem.sso}}
        </span>
      </div>
      <div class="grid-col text-center grid-col-80">
        <span class="grid-dtl-text">
          {{listItem.employmentStatus}}
        </span>
      </div>
      <div class="grid-col text-center grid-col-60">
        <div class="tooltips">
          <span class="grid-dtl-text">
            {{ listItem.requestedDate | date:'MM/dd/yyyy' }}
          </span>
          <span class="tooltiptext text" *ngIf="listItem.requestNumber!=''">Request # {{listItem.requestNumber}}</span>
        </div>
      </div>

      <div class="grid-col  text-center grid-col-80">
        <span class="grid-dtl-text">
          {{listItem.contactType}}
        </span>
      </div>

      <div *ngIf="hasTalentSu" class="grid-col  text-center grid-col-80">
        <div *ngIf="listItem.isVendor">
          <span class="grid-dtl-text">N/A</span>
        </div>
        <div *ngIf="!listItem.isVendor">
          <span class="grid-dtl-text">
            {{listItem.i9VerifyReason?.description}}
          </span>
        </div>
      </div>

      <div *ngIf="hasTalentSu" class="grid-col  text-center grid-col-80">
        <span class="grid-dtl-text">
          {{listItem.sapNo}}
        </span>
      </div>

      <div *ngIf="hasTalentSu" class="grid-col grid-col-hlight text-center grid-col-60">
        <div *ngIf="listItem.isVendor">
          <span class="grid-dtl-text">N/A</span>
        </div>
        <div *ngIf="!listItem.isVendor">
          <input type="checkbox"
                 [(ngModel)]="listItem.isTafSubmitted"
                 disabled />
        </div>
      </div>

      <div class="grid-col  text-center grid-col-100 grid-col-hlight">
        <span class="grid-dtl-text">
          {{listItem.onboardngStatus}} by: {{listItem.onboardingStatusUpdatedBy}} on {{listItem.onboardingStatusUpdatedDate}}
        </span>
      </div>

    </div>

  </div>

</div>
